import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ui-atom-sensitive-badge',
  standalone: true,
  imports: [MatTooltip, TranslatePipe],
  templateUrl: './ui-atom-sensitive-badge.component.html',
  styleUrl: './ui-atom-sensitive-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiAtomSensitiveBadgeComponent {}
